export default __webpack_public_path__ + "static/chong-0c6944352ed639ba47c7d76cb4acead4.jpg";